import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { connect as connectFormik } from "formik";
import { withLocalize } from "react-localize-redux";
import BbInput from "../../styling/bbInput";
import MarketingSection from "../marketingSection";
import PopupMultiSelectButton from '../../common/popupMultiSelectButton';
import { domainActions } from '../../../store/domainStore';
import { unicornAttribute } from "../../../store/marketingListStore";
import ErrorComponent from '../../common/errorComponent';

const MAX_SELECTED_NODES = 100;
class AddressPremises extends Component {
    
    render() {
        return (<>
            <BbInput type='custom' disabled={this.regionDisabled()} label={this.props.translate('Search.Label.Region')} placeholder={{ type: 'column' }} custom={
                <PopupMultiSelectButton
                    title={this.props.translate('Search.Label.Region')}
                    data='regions'
                    name='premises.regions'
                    onClick={() => this.props.ensureDomainData('regions', { marketAttribute: unicornAttribute() })}
                    selection={this.props.formik.values.premises.regions}
                    handleChange={(all, parent) => {
                        this.props.formik.setFieldValue('premises.regions.all', all);
                        this.props.formik.setFieldValue('premises.regions.parent', parent);
                    }}
                    disabled={this.regionDisabled()}
                />
            } />
            <BbInput type='custom' disabled={this.districtDisabled()} label={this.props.translate('Search.Label.District')} placeholder={{ type: 'column' }} custom={
                <PopupMultiSelectButton
                    title={this.props.translate('Search.Label.District')}
                    data='districts'
                    name='premises.districts'
                    onClick={() => this.props.ensureDomainData('districts', { marketAttribute: unicornAttribute() })}
                    selection={this.props.formik.values.premises.districts}
                    handleChange={(all, parent) => {
                        this.props.formik.setFieldValue('premises.districts.all', all);
                        this.props.formik.setFieldValue('premises.districts.parent', parent);
                    }}
                    disabled={this.districtDisabled()}
                />
            } />

            <BbInput type='custom' disabled={this.cityDisabled()} label={this.props.translate('Search.Label.Municipality')} placeholder={{ type: 'column' }} custom={
                <PopupMultiSelectButton
                    title={this.props.translate('Search.Label.Municipality')}
                    data='cities'
                    name='premises.cities'
                    onClick={() => this.props.ensureDomainData('cities', { marketAttribute: unicornAttribute() })}
                    selection={this.props.formik.values.premises.cities}
                    handleChange={(all, parent) => {                        
                        this.props.formik.setFieldValue('premises.cities.all', all);
                        this.props.formik.setFieldValue('premises.cities.parent', parent);
                    }}
                    showCustomError={() => this.showCustomError()}
                    maxSelectedNodes= {MAX_SELECTED_NODES}
                    disabled={this.cityDisabled()}
                    disableSelectAll
                />
            } />

                    <BbInput label={this.props.translate("Search.Address.Street")} name={`premises.street`} type="text" placeholder={{ type: 'column' }} />
                    <BbInput label={this.props.translate("Search.Address.Zip")} name={`premises.zip`} type="text" placeholder={{ type: 'column' }} />
       </>);
    }

    showCustomError = () => {
        if (this.props.formik.values.addr.cities.all.length > MAX_SELECTED_NODES) {
            return <ErrorComponent message="MarketingList.Error.Premises.Cities" style={ {display: 'block'}}></ErrorComponent>
        } 
        return (<></>)
    }

    regionDisabled = () => {
        return (this.props.formik.values.premises.districts.all && (this.props.formik.values.premises.districts.all.length !== 0))
            || (this.props.formik.values.premises.cities.all && (this.props.formik.values.premises.cities.all.length !== 0))
    }

    districtDisabled = () => {
        return (this.props.formik.values.premises.regions.all && (this.props.formik.values.premises.regions.all.length !== 0))
            || (this.props.formik.values.premises.cities.all && (this.props.formik.values.premises.cities.all.length !== 0));
    }

    cityDisabled = () => {
        return (this.props.formik.values.premises.regions.all && (this.props.formik.values.premises.regions.all.length !== 0))
            || (this.props.formik.values.premises.districts.all && (this.props.formik.values.premises.districts.all.length !== 0));
    }
}

export default withLocalize(connectFormik(connect(
    state => state.domain,
    dispatch => bindActionCreators(domainActions, dispatch),
)(AddressPremises)));